<template>
  <div
    class="flex-stepper panel panel-body"
    style="flex: 0 0 auto"
  >
    <general-stepper
      :steps-info="stepsInfo"
      @finish="saveGoal"
      @changeStep="changeStep"
    >
      <!--contents step-->
      <template
        slot="content-step-1"
        class="col-xs-12"
      >
        <div class="col-xs-12">
          <p>{{ trans('series.multiple_course_goal_explanation') }}</p>
        </div>

        <select-lessons
          :year="year"
          @canFinishStep="finishStep(1)"
          @canNotFinishStep="notFinishStep(1)"
        />
      </template>

      <template
        slot="content-step-2"
        class="col-xs-12"
      >
        <create-goal
          @canFinishStep="finishStep(2)"
          @canNotFinishStep="notFinishStep(2)"
        />
      </template>

      <template
        slot="content-step-3"
        class="col-xs-12"
      >
        <save-goal
          @canFinishStep="finishStep(3)"
          @canNotFinishStep="notFinishStep(3)"
        />
      </template>
    </general-stepper>
  </div>
</template>

<script>
import SelectLessons from '../EventSeriesPreview/SelectLessons.vue'
import CreateGoal from './CreateGoal.vue'
import SaveGoal from './SaveGoal.vue'
import toast from '../../../services/toast'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'AttendanceGoalSteps',
  components: {
    SelectLessons,
    CreateGoal,
    SaveGoal,
  },

  props: {
    year: {
      required: true,
    },
    load_rules: {
      default: null,
    },
    load_course_ids: {
      default: null,
    },
    load_event_serie_rule: {
      default: null,
    },
    load_filter_values: {
      default: null,
    },
    edit: {
      default: false,
    },
  },

  computed: {
    stepsInfo () {
      return this.$store.state.steps.steps_info
    },

    courses () {
      return this.$store.state.eventSeries.courses
    },
    events () {
      return this.$store.state.eventSeries.events
    },
  },

  created () {
    this.$store.dispatch('add_steps_info', {
      1: {
        step: 1,
        lessonSelector: true,
        title: Lang.get('series.titles.select_lessons'),
        finished: false,
      },
      2: {
        step: 2,
        lessonSelector: false,
        title: Lang.get('series.titles.component_rules'),
        finished: false,
      },
      3: {
        step: 3,
        lessonSelector: false,
        title: Lang.get('series.titles.confirmation'),
        finished: false,
      },
    },
    ).then(() => {
      this.$store.dispatch('set_active_step', { step: 1 })
    })

    this.$store.dispatch('add_serie_rules')

    if (this.edit === true) {
      this.loadEdit()
    }
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    loadCourses () {
      if (this.load_course_ids != null) {
        const promise = Object.values(this.load_course_ids).map(courseId => {
          return this.$store.dispatch('add_course', { courseId: courseId }).catch(error => defaultErrorMessage(error))
        })
        this.finishStep(1)
        return Promise.all(promise)
      }
      return Promise.resolve()
    },

    updateCourses () {
      if (this.load_filter_values != null) {
        const promise = this.load_filter_values.map(course => {
          let courseId = course['course_id']
          return Object.keys(course).map(name => {
            if (name === 'course_id') {
              return
            }
            let value = course[name]
            if (name === 'chosen_eventTypes' && typeof value === 'string') {
              if (value === Lang.get('core.all')) {
                return
              } else {
                value = [value]
              }
            }
            return this.$store.dispatch('update_course', { courseId: courseId, name: name, value: value })
          })
        })
        return Promise.all(promise)
      }
      return Promise.resolve()
    },

    loadRules () {
      if (this.load_rules != null) {
        const promise = Object.keys(this.load_rules).map(rule => {
          return this.$store.dispatch('update_serie_rules', { rule: rule, value: this.load_rules[rule] })
        })
        this.finishStep(2)
        this.finishStep(3)
        return Promise.all(promise)
      }
      return Promise.resolve()
    },

    loadEdit () {
      this.loadCourses().then(() => {
        this.updateCourses().then(() => {
          this.loadRules()
        })
      })
    },

    saveGoal () {
      let serie_rules = this.$store.state.eventSeries.serie_rules
      let course_information = this.$store.state.eventSeries.courses
      if (Object.keys(course_information).length === 0 || serie_rules == null || Object.keys(serie_rules).length === 0 ||
          serie_rules.type == null || serie_rules.goal_name == null || serie_rules.goal_name === '') {
        toast.error(Lang.get('series.save_empty_goal'))
      } else {
        let route = (this.edit && this.load_event_serie_rule != null) ? `/admin/attendance-goals/${this.load_event_serie_rule.id}/edit` : '/admin/attendance-goals'
        axios.post(route, { serie_rules: serie_rules, course_information: course_information })
          .then((response) => {
            if ('redirect' in response.data) {
              window.location.href = response.data.redirect
            } else {
              toast.success(response.data.message)
            }
          }).catch(error => defaultErrorMessage(error))
      }
    },
  },
}
</script>

<style>
    .flex-stepper {
        flex: 1 1 auto;
        overflow: auto;
    }

    .v-stepper {
        margin-bottom: 15px;
    }
</style>
